module.exports = __webpack_public_path__ + "img/img01.01652f31.jpg";